import { confirmsCaptionRemoval } from "@core-ui/toggleSignature";
import t from "@ext/localization/locale/translate";
import { ConfirmPopover } from "@ui-kit/ConfirmPopover";
import { GlassToolbarIcon, GlassToolbarToggleButton } from "@ui-kit/GlassToolbar";

interface CaptionToggleButtonProps {
	active: boolean;
	caption: string | null;
	tooltipText: string;
	onToggle: () => void;
	"data-testid"?: string;
}

const CaptionToggleButton = (props: CaptionToggleButtonProps) => {
	const { active, caption, tooltipText, onToggle, "data-testid": testId } = props;
	const confirmRemoval = confirmsCaptionRemoval(active, caption);

	return (
		<ConfirmPopover
			confirmText={t("confirmation.remove-caption.buttons.primary")}
			description={t("confirmation.remove-caption.body")}
			disabled={!confirmRemoval}
			icon="triangle-alert"
			onConfirm={onToggle}
			status="warning"
			title={t("confirmation.remove-caption.title")}
		>
			{/* A non-focusable toolbar button cancels its click, and a cancelled click never opens the popover. */}
			<GlassToolbarToggleButton
				active={active}
				aria-label={tooltipText}
				aria-pressed={active}
				data-testid={testId}
				focusable={confirmRemoval}
				onClick={confirmRemoval ? undefined : onToggle}
				tooltipText={tooltipText}
			>
				<GlassToolbarIcon icon="captions" />
			</GlassToolbarToggleButton>
		</ConfirmPopover>
	);
};

export default CaptionToggleButton;
